import React, { useState } from "react";
import { markAttendance } from "./attendance";

const API = "http://127.0.0.1:8000";

export default function StudentMark() {
  const [sessionId, setSessionId] = useState("");
  const [regno, setRegno] = useState("");

  const submit = async () => {
    if (!sessionId || !regno) {
      alert("Please enter Session ID and Registration Number");
      return;
    }

    // 🔒 Check session status before marking
    const res = await fetch(`${API}/session/${sessionId}/status`);
    const data = await res.json();

    if (!data.active) {
      alert("Attendance session has ended");
      return;
    }

    const result = markAttendance(sessionId, regno);
    alert(result === "stored" ? "Attendance Recorded" : "Already Marked");
  };

  return (
    <div style={{ padding: 20 }}>
      <h2>Student Attendance</h2>

      <input
        placeholder="Session ID"
        onChange={e => setSessionId(e.target.value)}
      />

      <input
        placeholder="Registration Number"
        onChange={e => setRegno(e.target.value)}
      />

      <button onClick={submit}>Mark Attendance</button>
    </div>
  );
}